"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  root: {
    padding: '16px',
    borderBottom: '1px solid rgba(0, 0, 0, .125)'
  }
};
exports["default"] = _default;